import request from 'config/axios'

const URL = '/registrar/v1/customers/residentialaddress'

export const getAddressInfo = () => request.get(URL) // eslint-disable-line

const config = { headers: { 'Content-Type': 'multipart/form-data' } }
export const sendAddressInfo = payload => request.put(URL, payload, config) // eslint-disable-line
